// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3531":"css/admin-app.6995","7116":"css/app.6995"}[chunkId] + ".css";
};